import React, { useEffect, useState, useRef } from "react";
import { useLocation, Link as RouterLink } from "react-router-dom";
import { Box, Button, Alert, AlertIcon, Spinner } from "@chakra-ui/react";

const VerifyEmail = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const token = query.get("token");

  const [status, setStatus] = useState(null); // "success", "already", "error"
  const [loading, setLoading] = useState(true);

  // Ref to prevent double execution in StrictMode
  const hasVerified = useRef(false);

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setLoading(false);
      return;
    }

    // Prevent double verification
    if (hasVerified.current) return;
    hasVerified.current = true;

    const verify = async () => {
      try {
        const backendUrl =
          process.env.NODE_ENV === "production"
            ? process.env.REACT_APP_API_URL
            : "http://localhost:3000";

        const res = await fetch(
          `${backendUrl}/api/auth/verify-email?token=${token}`
        );
        const data = await res.json();

        if (data.status === "success") {
          setStatus("success");
        } else if (
          data.status === "error" &&
          data.message?.toLowerCase().includes("already verified")
        ) {
          setStatus("already");
        } else {
          setStatus("error");
        }
      } catch (err) {
        console.error("Verify email fetch error:", err);
        setStatus("error");
      } finally {
        setLoading(false);
      }
    };

    verify();
  }, [token]);

  if (loading) return <Spinner size="xl" mx="auto" mt="100px" />;

  return (
    <Box
      maxW="500px"
      mx="auto"
      mt="100px"
      p="6"
      borderWidth="1px"
      borderRadius="lg"
      boxShadow="md"
      textAlign="center"
    >
      {status === "success" && (
        <>
          <Alert status="success" mb={6}>
            <AlertIcon />
            Your email has been verified successfully! You can now log in.
          </Alert>
          <Button as={RouterLink} to="/login" colorScheme="teal">
            Go to Login
          </Button>
        </>
      )}

      {status === "already" && (
        <>
          <Alert status="info" mb={6}>
            <AlertIcon />
            Your email was already verified. You can log in.
          </Alert>
          <Button as={RouterLink} to="/login" colorScheme="teal">
            Go to Login
          </Button>
        </>
      )}

      {status === "error" && (
        <>
          <Alert status="error" mb={6}>
            <AlertIcon />
            Verification failed or the link has expired. Please sign up again.
          </Alert>
          <Button as={RouterLink} to="/signup" colorScheme="red">
            Back to Signup
          </Button>
        </>
      )}
    </Box>
  );
};

export default VerifyEmail;
